module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wassen-8532109065863f913ab5a857e2106cf6.svg";